// Module
var code = "<div class=\"supplier-workspace\">\n  <supplier-workspace-header\n    supplier-id=\"vm.supplier.id\"\n  ></supplier-workspace-header>\n  <div class=\"supplier-workspace__content\" ui-view></div>\n</div>\n";
// Exports
module.exports = code;